import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultTranslation } from './locales/default/translation';
import { lifeTranslation } from './locales/life/translation';

i18n
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		lng: 'default',
		fallbackLng: 'default',
		debug: false,
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		resources: {
			life: lifeTranslation,
			default: defaultTranslation,
		},
	});

export default i18n;
